import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Switch, Route } from 'react-router-dom';

import Frame from '../Onboarding/Frame';
import Header from '../../components/Header';
import { LoadingBar } from '../../components/util/LoadingBar';

import PayOrSave from './PayOrSave';
import DisabilityInsurance from './DisabilityInsurance';
import LowerExpenses from './LowerExpenses';
import MarketVolatility from './MarketVolatility';
import RetirementIncome from './RetirementIncome';
import SpendingProfile from './SpendingProfile';

import { fetchDashboard } from '../../actions/dashboardActions';
import { fetchContentPages } from '../../actions/contentPagesActions';
import { fetchPeople } from '../../actions/peopleActions';
import { fetchOnboarding } from '../../actions/onboardingActions';

import { wlPath, wlVar } from '../../helpers/whitelabel';

// Calculators/index and Surveys/index use the same code.  Reflect changes in both files, or remove this notice.
export class Calculators extends Component {
  componentWillMount() {
    if (!this.props.dashboard.fetched || !this.props.dashboard.data.primary_person_id) {
      this.props.dispatch(fetchDashboard());
    }
    if (!this.props.people) {
      this.props.dispatch(fetchPeople());
    }
    if (!this.props.onboarding.fetched) this.props.dispatch(fetchOnboarding());
    if (!this.props.contentPages) {
      this.props.dispatch(fetchContentPages());
    }
  }

  render() {
    const { dashboard, history, match, user, contentPages, onboarding } = this.props;

    if (!user || !dashboard.fetched || !contentPages || !onboarding.fetched) {
      return <LoadingBar />;
    }

    if (!contentPages.length) {
      history.push(wlPath('/'));
    }

    if (!dashboard.data.primary_person_id) {
      return <LoadingBar />;
    }

    return (
      <Frame match={match}>
        <Switch>
          <Route exact path={match.url + '/pay-or-save'} component={PayOrSave} />
          <Route exact path={match.url + '/disability-insurance'} component={DisabilityInsurance} />
          <Route exact path={match.url + '/lower-expenses'} component={LowerExpenses} />
          <Route exact path={match.url + '/market-volatility'} component={MarketVolatility} />
          <Route exact path={match.url + '/retirement-income'} component={RetirementIncome} />
          <Route exact path={match.url + '/spending-profile'} component={SpendingProfile} />
        </Switch>
      </Frame>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.user,
    dashboard: state.modules.dashboard,
    people: state.modules.people,
    onboarding: state.onboarding,
    contentPages: state.contentPages.data,
  };
}

export default connect(mapStateToProps)(Calculators);
